import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import useRefreshToken from '../../hooks/useRefreshToken';
import useDeepLink from './hooks/useDeepLink';
import useLogin from './hooks/useLogin';
import usePar from './hooks/usePar';
import MainLayout from './MainLayout';
import SplashScreen from '../SplashScreen';
import useUser from '../../hooks/useUser';
import PATHNAME from './helpers/Pathname';
import { GoogleTagManager } from '../../helpers';

const AppControllerLogin = ({ location, children }) => {
  const user = useUser();
  const pathname = PATHNAME(location.pathname);
  const [validRefreshToken] = useRefreshToken();
  const login = useLogin();
  const { setDeepLink, redirectDeepLink } = useDeepLink();
  const parVerificated = usePar(location.pathname);
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  const hideSplashScreen = () => setShowSplashScreen(false);

  const SSOLogin = async () => {
    const { status } = await login();
    if (status === 403) {
      navigate('/darkside');
    } else if (status >= 400) {
      GoogleTagManager.tagInteractiveEvent({
        eventCategory: 'Redirección MiWOM',
        eventAction: `Usuario Redireccionado - ${status}`,
        eventTag: 'Redirección MiWOM',
      });
      setDeepLink({ location });
    }
  };

  useEffect(() => {
    if (parVerificated && !user) {
      SSOLogin();
    }
  }, [parVerificated, validRefreshToken]);

  useEffect(() => {
    if (user && !showSplashScreen) redirectDeepLink();
  }, [user, showSplashScreen]);

  if (showSplashScreen)
    return <SplashScreen hideSplashScreen={hideSplashScreen} />;

  return (
    <MainLayout location={location} pathname={pathname}>
      {children}
    </MainLayout>
  );
};

AppControllerLogin.propTypes = {
  location: PropTypes.instanceOf(Object).isRequired,
  children: PropTypes.node.isRequired,
};

export default AppControllerLogin;
